/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonRelay
 */
export interface JsonRelay {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonRelay
     */
    allowedActions?: Array<JsonRelayAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonRelay
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonRelay
     */
    episodeId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonRelay
     */
    finishedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonRelay
     */
    finishedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonRelay
     */
    relayGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonRelay
     */
    relayId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonRelay
     */
    startedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonRelay
     */
    startedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonRelay
     */
    status?: JsonRelayStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum JsonRelayAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonRelayStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Finished = 'FINISHED'
}

export function JsonRelayFromJSON(json: any): JsonRelay {
    return JsonRelayFromJSONTyped(json, false);
}

export function JsonRelayFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonRelay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'episodeId': !exists(json, 'episodeId') ? undefined : json['episodeId'],
        'finishedAt': !exists(json, 'finishedAt') ? undefined : json['finishedAt'],
        'finishedBy': !exists(json, 'finishedBy') ? undefined : json['finishedBy'],
        'relayGuid': !exists(json, 'relayGuid') ? undefined : json['relayGuid'],
        'relayId': !exists(json, 'relayId') ? undefined : json['relayId'],
        'startedAt': !exists(json, 'startedAt') ? undefined : json['startedAt'],
        'startedBy': !exists(json, 'startedBy') ? undefined : json['startedBy'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function JsonRelayToJSON(value?: JsonRelay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'episodeId': value.episodeId,
        'finishedAt': value.finishedAt,
        'finishedBy': value.finishedBy,
        'relayGuid': value.relayGuid,
        'relayId': value.relayId,
        'startedAt': value.startedAt,
        'startedBy': value.startedBy,
        'status': value.status,
    };
}

